<template>
  <div id="app">
    <!-- 导航栏模式 - 即需要缓存 -->
    <template v-if="$store.state.tagsView.hasNavBar">
      <keep-alive :include="$store.getters.cachedViews">
        <router-view></router-view>
      </keep-alive>
    </template>
    <!-- 面包屑模式 - 即不需要缓存 -->
    <template v-else>
      <router-view></router-view>
    </template>
  </div>
</template>

<script>
import AES from "@/mixins/AES";
import { eventBus } from "@/plugins/eventBus";
export default {
  data() {
    return {};
  },
  updated() {
    let _this = this;
    document.addEventListener("visibilitychange", function () {
      if (_this.$route.path == "/help") return;
      //当登录角色不一致强制重载页面
      let id = document.getElementById("userName");
      let server = document.getElementById("server");
      if (server.innerText != window.localStorage.getItem("server")) {
        this.$router.replace(
          `/${window.localStorage.getItem("server")}/workBench`
        );
      } else if (
        id.innerText != window.localStorage.getItem("UserName").trim()
      ) {
        location.reload();
      }
    });
  },
  methods: {
    // 平台类型
    getChannelType() {
      if (!window.localStorage.getItem("channelType")) {
        console.log("平台类型");
        this.$api
          .post(
            "/api/DataDictionary/GetDataDictionaryCnEnID",
            "4356786200621312"
          )
          .then((res) => {
            window.localStorage.setItem(
              "channelType",
              AES.encrypt(JSON.stringify(res.data))
            );
          });
      }
    },
    // 国家
    getCountry() {
      if (!window.localStorage.getItem("country")) {
        console.log("国家");
        this.$api
          .post("/api/AdministrativeDivision/GetCountryBox")
          .then((res) => {
            window.localStorage.setItem(
              "country",
              AES.encrypt(JSON.stringify(res.data))
            );
          });
      }
    },
    // 币种
    getCurrency() {
      if (!window.localStorage.getItem("currency")) {
        console.log("币种");
        this.$api
          .post("/api/SysOnePieceFee/GetCurrencyDropList")
          .then((res) => {
            window.localStorage.setItem(
              "currency",
              AES.encrypt(JSON.stringify(res.data))
            );
          });
      }
    },
    // 员工
    getStaff() {
      if (!window.localStorage.getItem("staff")) {
        console.log("员工");
        this.$api.post("/api/SysUser/GetSysUserDropList").then((res) => {
          window.localStorage.setItem(
            "staff",
            AES.encrypt(JSON.stringify(res.data))
          );
        });
      }
    },
    // 中转仓
    getTransitWarehouse() {
      if (!window.localStorage.getItem("transitWarehouse")) {
        console.log("中转仓");
        this.$api
          .post(
            "/api/DataDictionary/GetDataDictionaryCnEnID",
            "4137470836912384"
          )
          .then((res) => {
            window.localStorage.setItem(
              "transitWarehouse",
              AES.encrypt(JSON.stringify(res.data))
            );
          });
      }
    },
    // 仓库（自提+派送）
    getWarehouseWithPickUpAndDeliver() {
      if (!window.localStorage.getItem("warehousePickUpAndDeliver")) {
        console.log("仓库（自提+派送）");
        this.$api.post("/system/stock/GetStockList").then((res) => {
          window.localStorage.setItem(
            "warehousePickUpAndDeliver",
            AES.encrypt(JSON.stringify(res.data))
          );
        });
      }
    },
    // 仓库
    getWarehouse() {
      if (!window.localStorage.getItem("warehouse")) {
        console.log("仓库");
        this.$api.post("/system/stock/GetStock").then((res) => {
          window.localStorage.setItem(
            "warehouse",
            AES.encrypt(JSON.stringify(res.data))
          );
        });
      }
    },
    // 商品货物属性
    getProductAndGoodsAttributes() {
      if (!window.localStorage.getItem("productAndGoodsAttributes")) {
        console.log("商品货物属性");
        let params = {
          longs: ["4851067289055488"],
          isbool: true,
        };
        this.$api
          .post("/api/DataDictionary/GetDataDictionaryCnEnList", params)
          .then((res) => {
            this.optsData = res.data;
            window.localStorage.setItem(
              "productAndGoodsAttributes",
              AES.encrypt(JSON.stringify(res.data))
            );
          });
      }
    },

    // 浏览器前进后退
    handlePopstate() {
      eventBus.$emit("changeHeaderActiveMenu");
    },
  },
  watch: {
    $route: {
      handler(val, oldValue) {
        if (
          (val.path == "/login/admin" || val.path == "/login") &&
          oldValue.path != "/"
        ) {
          eventBus.$on("getChannelType", this.getChannelType);
          eventBus.$on("getCountry", this.getCountry);
          eventBus.$on("getCurrency", this.getCurrency);
          eventBus.$on("getStaff", this.getStaff);
          eventBus.$on("getTransitWarehouse", this.getTransitWarehouse);
          eventBus.$on(
            "getWarehouseWithPickUpAndDeliver",
            this.getWarehouseWithPickUpAndDeliver
          );
          eventBus.$on("getWarehouse", this.getWarehouse);
          eventBus.$on(
            "getProductAndGoodsAttributes",
            this.getProductAndGoodsAttributes
          );
        }
      },
    },
  },
  mounted() {
    eventBus.$on("getChannelType", this.getChannelType);
    eventBus.$on("getCountry", this.getCountry);
    eventBus.$on("getCurrency", this.getCurrency);
    eventBus.$on("getStaff", this.getStaff);
    eventBus.$on("getTransitWarehouse", this.getTransitWarehouse);
    eventBus.$on(
      "getWarehouseWithPickUpAndDeliver",
      this.getWarehouseWithPickUpAndDeliver
    );
    eventBus.$on("getWarehouse", this.getWarehouse);
    eventBus.$on(
      "getProductAndGoodsAttributes",
      this.getProductAndGoodsAttributes
    );
    // 页面刷新后，从localStorage中获取navList
    let navList = localStorage.getItem("navList");
    if (navList) {
      this.$store.commit("SET_NAV_LIST", JSON.parse(navList));
    }
    // 页面刷新后，从localStorage中获取navList
    let pageStyle = window.localStorage.getItem("pageStyle");
    if (pageStyle == 0) {
      this.$store.commit("SET_HAS_NAV_BAR", true);
    }
    // 监听浏览器前进后退
    window.addEventListener("popstate", this.handlePopstate, false);
  },
  // 移除监听
  beforeDestroy() {
    window.removeEventListener("popstate", this.handlePopstate, false);
  },
};
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;
}
* {
  padding: 0;
  margin: 0;
}
@import "./assets/style/base.scss";
</style>
